import {firstValueFrom} from 'rxjs';
import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../../services/auth/auth";

export const authGuard: CanActivateFn = async (route, state) => {
  const auth: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  await auth.loadToken();
  if (auth.isLoggedIn()) {
    try {
      // Resolve the user's role before activating a page inside the corresponding app shell.
      if (!auth.currentUser()) await firstValueFrom(auth.loadCurrentUser());
      if (auth.isLoggedIn()) return true;
    } catch {
      // A failed session check must not start protected page requests.
    }
  }

  return router.createUrlTree(['/login'], {
    queryParams: {
      redirect: state.url,
    },
  });
};
